export default {
    updateAttendance: 'Edit Attendance',
    cancel: 'Cancel',
    save: 'Save',
    profile: 'Profile',
    status: 'Status',
    date: 'Date',
    name: 'Full Name',
    group: 'Group',
    department: 'Department',
    ontime: 'Ontime',
    late: 'Late',
    absent: 'Absent',
    activityLog: 'Activity Log',
    thereIsNoActivityLog: 'There is no activity log',
    congratulation: 'Congratulation',
    errorMessage: 'Error Message',
    checkIn: 'Check-In',
    checkOut: 'Check-Out',
    thisFieldIsRequired: 'This field is required',
    errorTime: 'Error Time',
    errorSeleteTime: 'Error select time',
    seletePeriod: 'Please select the time in period of',
    seleteBefore: 'Please select the time before or at the time of',
    seletemoreThanTimeStart: 'Please select the time more than time start'
}
